import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import * as S from "./style";
//Icons
import { Info, Invoice } from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//components
import ImgOrder from "../../../../assets/ImgOrder.png";
import ActionButton from "../../../Button/ActionButton";
import DetailsProduct from "../../../../components/DetailsProduct";
import DetailsUser from "../../../../components/Modals/User/Details";
import DetailsCustom from "../../Customer/Details";
import Invoices from "../../Invoices/Details";
import Loading from "../../../Loading";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
//utils
import { CurrencyFormat, formatPercentage } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";
import TruncateText from "utils/TruncateText";
//Interface
import { ICard } from "Interfaces/ICard";
import { IOrder } from "Interfaces/IOrder";
import { IPaymentCredits } from "Interfaces/IPayCredit";
import { IUser } from "Interfaces/IUser";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {
  const [data, setData] = useState<IOrder | null>(null);
  const [dataUser, setDataUser] = useState<IUser[]>([]);
  const [invoice, setInvoice] = useState<IPaymentCredits | null>(null);
  const [agreements, setAgreements] = useState("");
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [installmentId, setInstallmentId] = useState<number | null>(null);
  const [customerName, setCustomerName] = useState("");
  const [card, setCard] = useState<ICard[]>([]);
  let count = 0;

  const fetchData = async () => {
    startLoading();
    try {
      const [response, responseCard, responseUser] = await Promise.all([
        axiosInstance.get(`sale/${selectedUrlId}`),
        axiosInstance.get(`card`),
        axiosInstance.get(`user`),
      ])
      const invoiceData = response.data[0].payment_credits;

      setData(response.data[0]);
      setAgreements(response.data?.agreement);
      setInvoice(invoiceData[0]);
      setCard(responseCard.data);
      setDataUser(responseUser.data.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const clickInvoices = (id: number, nameCustomer: string) => {
    setInstallmentId(id);
    setCustomerName(nameCustomer);
    toggleModalVisibility("invoices");
  };

  const getCardNameById = (id: number, url: string, data: ICard[]) => {
    if (url === 'credito') {
      const card = data.find((card: ICard) => card.id === id);
      return card?.number_installment || "Cartão não identificado";
    }
  };

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Venda"
        subTitle="Veja todos os detalhes disponíveis sobre a armação."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgOrder} alt="Imagem Óculos" />
              </S.ContentImage>

              <S.ContentInfor>
                <S.Infor>
                  <p>N° da Venda:</p>
                  <span>{data.number_ata || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Data da venda:</p>
                  <span>{FormatarData(data.date_sale, 'default') || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Vendedor:</p>
                  <span>
                    {data.user?.first_name || "-"} (
                    {TruncateText(data.user?.email, 8) || "-"})
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>Preço:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.total_amount || "0"))}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>

              {/* Cliente */}
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>
                      Cliente
                      {data.customer && (
                        <S.Button>
                          <Info
                            size={16}
                            onClick={() => toggleModalVisibility("details")}
                          />
                        </S.Button>
                      )}
                    </p>
                    <span>{data.customer?.full_name || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Contato</p>
                    <span>{data.customer?.phone_primary || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>CPF</p>
                    <span>{data.customer?.cpf || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Convênio</p>
                    <span>{agreements || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>
              {/* Fim Cliente */}

              {/* Inicio Pagamentos */}
              <S.FeaturedSection>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Forma de Pagamento</p>
                    <span>{data.payment_method.payment_method || '-'}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Valor</p>
                    <span>
                      {CurrencyFormat(parseFloat(data.total_amount || "0")) ||
                        "0"}
                    </span>
                  </S.InforBody>

                  {
                    data.payment_credits.length > 0 && (
                      <S.ContentBody>
                        <S.InforBody>
                          <p>Entrada</p>
                          <span>{CurrencyFormat(parseFloat(data.payment_credits[0].down_payment) || 0)}</span>
                        </S.InforBody>
                      </S.ContentBody>
                    )
                  }
                </S.ContentBody>

                {
                  data.credit_cards.length > 0 && (
                    <S.ContentBody>
                      <S.InforBody>
                        <p>Plano</p>
                        <span>{getCardNameById(data.credit_cards[0].card_id
                          , 'credito', card)}x</span>
                      </S.InforBody>
                    </S.ContentBody>
                  )
                }
              </S.FeaturedSection>
              {/* Fim Pagamento */}


              <S.Section>
                <S.ContentBody>
                  {/* frame */}
                  {data.frames.length > 0 &&
                    data.frames.map((val, index) => {
                      count = index + 1;
                      const cash = data.cash_promotions;
                      const credit = data.credit_promotions;

                      // Encontra o item específico na promoção
                      const cashPromo = cash.length > 0 ? cash.find((item) => item.id === val.pivot.paymentable_id) : null;
                      const creditPromo = credit.length > 0 ? credit.find((item) => item.id === val.pivot.paymentable_id) : null;

                      // Determina qual promoção aplicar (cash ou credit)
                      const activePromo = cashPromo || creditPromo;

                      //Usuário Autorizador
                      const user_auth = dataUser.find((item) => item.id === val.pivot.user_id);

                      return (
                        <DetailsProduct
                          type_product={"Armação"}
                          count={count}
                          amount={val.pivot?.quantity || 0}
                          code={val?.code || "-"}
                          total={CurrencyFormat(parseFloat(val.pivot?.total || "0")) || "0"}
                          value_unit={CurrencyFormat(parseFloat(val?.price || "0")) || "0"}

                          // Passa os valores individuais, com fallback para string vazia
                          auth={activePromo ? activePromo.promotion.auth : ""}
                          discount={activePromo ? formatPercentage(parseFloat(activePromo.discount || '0')) : ""}
                          payment={activePromo ? activePromo.form_payment?.form_payment || `Credito (${activePromo?.installment}x)` : ''}
                          title_promo={activePromo ? activePromo.promotion.title : ""}
                          user={user_auth?.first_name}
                        />

                      );
                    })}

                  {/* service */}
                  {data.services.length > 0 &&
                    data.services.map((val, index) => {
                      count += index + 1;
                      const cash = data.cash_promotions;
                      const credit = data.credit_promotions;

                      // Encontra o item específico na promoção
                      const cashPromo = cash.length > 0 ? cash.find((item) => item.id === val.pivot.paymentable_id) : null;
                      const creditPromo = credit.length > 0 ? credit.find((item) => item.id === val.pivot.paymentable_id) : null;

                      // Determina qual promoção aplicar (cash ou credit)
                      const activePromo = cashPromo || creditPromo;

                      //Usuário Autorizador
                      const user_auth = dataUser.find((item) => item.id === val.pivot.user_id);

                      return (
                        <DetailsProduct
                          type_product={"Serviço"}
                          count={count}
                          code={val?.name || "-"}
                          value_unit={CurrencyFormat(parseFloat(val?.price || "0")) || "0"}
                          amount={val.pivot?.quantity || 0}
                          total={CurrencyFormat(parseFloat(val.pivot?.total || "0")) || "0"}

                          // Promo
                          auth={activePromo ? activePromo.promotion.auth : ""}
                          discount={activePromo ? formatPercentage(parseFloat(activePromo.discount || '0')) : ""}
                          payment={activePromo ? activePromo.form_payment?.form_payment || `Credito (${activePromo?.installment}x)` : ''}
                          title_promo={activePromo ? activePromo.promotion.title : ""}
                          user={user_auth?.first_name}
                        />

                      );
                    })}
                  {/* lentes */}
                  {data.lenses.length > 0 &&
                    data.lenses.map((val, index) => {
                      count += index + 1;
                      const cash = data.cash_promotions;
                      const credit = data.credit_promotions;

                      // Encontra o item específico na promoção
                      const cashPromo = cash.length > 0 ? cash.find((item) => item.id === val.pivot.paymentable_id) : null;
                      const creditPromo = credit.length > 0 ? credit.find((item) => item.id === val.pivot.paymentable_id) : null;

                      // Determina qual promoção aplicar (cash ou credit)
                      const activePromo = cashPromo || creditPromo;

                      //Usuário Autorizador
                      const user_auth = dataUser.find((item) => item.id === val.pivot.user_id);

                      return (
                        <DetailsProduct
                          type_product={"Lente"}
                          count={count}
                          code={val?.name_lens || "-"}
                          value_unit={CurrencyFormat(parseFloat(val?.price || "0")) || "0"}
                          amount={val.pivot?.quantity || 0}
                          total={CurrencyFormat(parseFloat(val.pivot?.total || "0")) || "0"}

                          // Promo
                          auth={activePromo ? activePromo.promotion.auth : ""}
                          discount={activePromo ? formatPercentage(parseFloat(activePromo.discount || '0')) : ""}
                          payment={activePromo ? activePromo.form_payment?.form_payment || `Credito (${activePromo?.installment}x)` : ''}
                          title_promo={activePromo ? activePromo.promotion.title : ""}
                          user={user_auth?.first_name}
                        />
                      );
                    })}
                </S.ContentBody>
              </S.Section>

              {invoice?.id && (
                <S.ContentButton>
                  <ActionButton
                    Icon={<Invoice size={20} />}
                    name="Faturas"
                    onClick={() =>
                      clickInvoices(invoice.id, data.customer?.full_name)
                    }
                  />
                </S.ContentButton>
              )}
            </S.Body>

            <DetailsCustom
              isOpenModalDetails={isOpenModal("details")}
              setModalClose={() => toggleModalVisibility("details")}
              selectedUrlId={data.customer.id}
            />

          </S.Content>
        )}


        <Invoices
          customerName={customerName}
          isOpenModalDetails={isOpenModal("invoices")}
          setModalClose={() => toggleModalVisibility("invoices")}
          selectedUrlId={installmentId}
        />
      </LayoutDetails>
    );
  }
  return null;
}
